<template>
  <div id="ticket-main-section-left-column" class="ticket-main-section-left-column flex-grow-1">
    <ticket-intro-fixed v-if="showFixedIntro"></ticket-intro-fixed>
    <div class="container-fluid px-3 pt-3">
      <ticket-closing-note v-if="ticket.closing_note && ticket.status == 3"></ticket-closing-note>
      
      <ticket-intro></ticket-intro>


      <div v-waypoint="{ active: true, callback: onIntroWaypoint }"></div>

      <!-- View Deleted -->
      <div class="form-group mb-1 view-deleted-wrapper">
        <label class="d-inline-block" for="viewDeleted">View Deleted Notes?</label>

        <b-form-checkbox class="d-inline-block"
                         v-model="show_deleted" name="check-button" switch>
        </b-form-checkbox>
      </div>
      <!-- / View Deleted -->

      <!--            <div class="section-title">-->
      <!--                <h3>Event Log</h3>-->
      <!--                <hr>-->
      <!--            </div>-->

      <div v-for="(item, i) in feed" :key="i">
        <ticket-note v-if="item.type === 'note'" :note="item.object"></ticket-note>
        <ticket-forwarding-log v-if="item.type === 'forwarding-log'"
                               :forwarding-log="item.object"></ticket-forwarding-log>

        <ticket-reply v-if="item.type === 'reply'"
                      :reply="item.object"></ticket-reply>

        <logged-email v-if="item.type === 'logged-email'"
                      :logged-email="item.object"></logged-email>

        <inbound-email v-if="item.type === 'inbound-email'"
                       :inbound-email="item.object"></inbound-email>

        <ticket-sms-log v-if="item.type === 'sms-log'"
                        :sms-log="item.object"></ticket-sms-log>

        <ticket-whatsapp-log v-if="item.type === 'whatsapp-log'"
                             :whatsapp-log="item.object"></ticket-whatsapp-log>

        <ticket-inbound-text-message v-if="item.type === 'inbound-text-message'"
                                     :inbound-text-message="item.object"></ticket-inbound-text-message>

        <ticket-inbound-whatsapp-message v-if="item.type === 'inbound-whatsapp-message'"
                                        :inbound-whatsapp-message="item.object"></ticket-inbound-whatsapp-message>

        <ticket-expense v-if="item.type === 'expense'"
                        :expense="item.object"></ticket-expense>
      </div>

      <!-- Actions -->
      <ticket-actions v-show="selectedAction === null"></ticket-actions>
      <create-ticket-note v-if="selectedAction === 'add-note'"></create-ticket-note>
      <forward-ticket v-if="selectedAction === 'forward-ticket'"></forward-ticket>
      <send-sms v-if="selectedAction === 'send-sms'"></send-sms>
      <send-whatsapp v-if="selectedAction === 'send-whatsapp'"></send-whatsapp>
      <reply v-if="selectedAction === 'reply'"></reply>
      <!-- / Actions -->
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

import TicketIntro from "./widgets/TicketIntro";
import TicketNote from "./widgets/TicketNote";
import TicketForwardingLog from "./widgets/TicketForwardingLog";
import TicketReply from "./widgets/TicketReply";
import LoggedEmail from "./widgets/LoggedEmail";
import InboundEmail from "./widgets/InboundEmail";
import TicketSmsLog from "./widgets/TicketSmsLog";
import TicketWhatsappLog from "./widgets/TicketWhatsappLog";
import TicketInboundTextMessage from "./widgets/TicketInboundTextMessage";
import TicketInboundWhatsappMessage from "./widgets/TicketInboundWhatsappMessage";
import TicketClosingNote from "./widgets/TicketClosingNote";
import TicketExpense from "./widgets/TicketExpense.vue";
import IncidentReportIntro from "./widgets/IncidentReportIntro.vue";

import TicketActions from "./widgets/TicketActions";
import CreateTicketNote from "./widgets/CreateTicketNote";
import ForwardTicket from "./widgets/ForwardTicket";
import SendSms from "./widgets/SendSms";
import SendWhatsapp from "./widgets/SendWhatsapp";
import Reply from "./widgets/Reply";
import TicketIntroFixed from './widgets/TicketIntroFixed.vue';

export default {
  name: "TicketMainSectionLeftColumn",

  data() {
    return {
      showFixedIntro: false
    }
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      selectedAction: 'selectedAction',
      showDeleted: 'showDeleted',
      expenses: 'expenses',
      incidentReport: 'incidentReport'
    }),

    show_deleted: {
      get() {
        return this.showDeleted;
      },
      set(val) {
        this.setShowDeleted(Boolean(val));
      }
    },

    feed() {
      let feed = [];

      _.each(this.ticket.ticket_notes, (note) => {
        feed.push({
          type: 'note',
          object: this.buildTimelineObject(note)
        });
      });

      _.each(this.ticket.ticket_forwarding_logs, (forwardingLog) => {
        feed.push({
          type: 'forwarding-log',
          object: this.buildTimelineObject(forwardingLog)
        });
      });

      _.each(this.ticket.ticket_replies, (reply) => {
        feed.push({
          type: 'reply',
          object: this.buildTimelineObject(reply)
        });
      });

      _.each(this.ticket.logged_emails, (loggedEmail) => {
        feed.push({
          type: 'logged-email',
          object: this.buildTimelineObject(loggedEmail)
        });
      });

      _.each(this.ticket.inbound_emails, (inboundEmail) => {
        feed.push({
          type: 'inbound-email',
          object: this.buildTimelineObject(inboundEmail)
        });
      });

      _.each(this.ticket.ticket_sms_logs, (smsLog) => {
        feed.push({
          type: 'sms-log',
          object: this.buildTimelineObject(smsLog)
        });
      });

      _.each(this.ticket.ticket_whatsapp_logs, (whatsappLog) => {
        feed.push({
          type: 'whatsapp-log',
          object: this.buildTimelineObject(whatsappLog)
        });
      });

      _.each(this.ticket.inbound_text_messages, (inboundTextMessage) => {
        feed.push({
          type: 'inbound-text-message',
          object: this.buildTimelineObject(inboundTextMessage)
        });
      });

      _.each(this.ticket.inbound_whatsapp_messages, (inboundWhatsappMessage) => {
        feed.push({
          type: 'inbound-whatsapp-message',
          object: this.buildTimelineObject(inboundWhatsappMessage)
        });
      });

      _.each(this.expenses, (expense) => {
        feed.push({
          type: 'expense',
          object: this.buildTimelineObject(expense)
        });
      });

      return _.sortBy(feed, 'object.created_at');
    }
  },

  components: {
    TicketIntro,
    TicketNote,
    TicketActions,
    CreateTicketNote,
    ForwardTicket,
    Reply,
    TicketForwardingLog,
    TicketReply,
    LoggedEmail,
    InboundEmail,
    SendSms,
    SendWhatsapp,
    TicketSmsLog,
    TicketWhatsappLog,
    TicketInboundTextMessage,
    TicketInboundWhatsappMessage,
    TicketClosingNote,
    TicketIntroFixed,
    TicketExpense,
    IncidentReportIntro
  },

  methods: {
    ...mapActions('ticketViewer', {
      setShowDeleted: 'setShowDeleted'
    }),

    onIntroWaypoint(e) {
      console.log(e);
      if (e.going == 'out') {
        this.showFixedIntro = true;
      } else {
        this.showFixedIntro = false;
      }
    },

    buildTimelineObject(obj) {
      // Create a copy of the object to avoid mutating the original
      const timelineObj = { ...obj };
      
      // Check if this object has split tracking properties
      if (obj.split_to_ticket_id && obj.split_at && obj.split_by_user_id) {
        timelineObj.split_tracking = {
          split_to_ticket_id: obj.split_to_ticket_id,
          split_at: obj.split_at,
          split_by_user_id: obj.split_by_user_id
        };
      }
      
      return timelineObj;
    }
  },

  mounted() {
    let container = document.getElementById('ticket-main-section-left-column');
    container.scrollTo({top: 0, behavior: "auto"});
  }
}
</script>

<style scoped lang="scss">
.ticket-main-section-left-column {
  position: relative;
  overflow-y: scroll;

  // &::-webkit-scrollbar {
    // display: none;
  // }
}

.view-deleted-wrapper {
  display: flex;
  justify-content: flex-end;

  label {
    margin-right: 10px;
  }
}
</style>
